import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ButtonBase from '@material-ui/core/ButtonBase'
import Collapse from '@material-ui/core/Collapse'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import CardActions from '@material-ui/core/CardActions'
import Divider from '@material-ui/core/Divider'
import Chip from '@material-ui/core/Chip'
import CardHeader from '@material-ui/core/CardHeader'

import AddIcon from '@material-ui/icons/Add'
import FlagIcon from '@material-ui/icons/Flag'
import InfoIcon from '@material-ui/icons/Info'
import SettingsIcon from '@material-ui/icons/Settings'
import ChatBubbleIcon from '@material-ui/icons/ChatBubble'
import GroupIcon from '@material-ui/icons/Group'
import SendIcon from '@material-ui/icons/Send'
import CallMadeIcon from '@material-ui/icons/CallMade'
import CallReceivedIcon from '@material-ui/icons/CallReceived'
import CachedIcon from '@material-ui/icons/Cached'
import UndoIcon from '@material-ui/icons/Undo'
import blue from '@material-ui/core/colors/blue'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import VpnKeyIcon from '@material-ui/icons/VpnKey'

import ConfirmDialog from '../../../components/Common/ConfirmDialog'

import { openingRuleItems, gameType, roomStatus, RESULT_OFFER_DRAW, ENDED_ACTION, CHAT_TYPE, OPENING_RULE, PLAYER_TYPE } from '../../../constants'
import { getBreakpointsEnable, makeLiveGameResultStr, coordinateXString, coordinateYString, makePath } from '../../../lib'
import { PlayerBox } from '../containers'
import { ControlCard, Word } from '../../../containers'
import { GameResultBox } from './CommonComponents';
import { WID, getWord } from '../../../constants/Language';
import MenuItem from '@material-ui/core/MenuItem'
import { useState } from 'react'
import { useContext } from 'react'
import { GameContext } from '../GameProvider'
import { useRef } from 'react'
import { useEffect } from 'react'
import { Dialog, DialogActions, DialogContent, FormControl, Input, InputAdornment, InputLabel, List, ListItem, ListItemSecondaryAction, ListItemText, Switch } from '@material-ui/core'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'
import { Link } from 'react-router-dom'
import { SettingsContext } from '../../../Parts/Settings'

const stylesForGameInfoCardHeader = theme => ({
  cardHeader: {
    backgroundColor: theme.palette.grey[100],
  },
  roomNumber: {
    marginRight: theme.spacing.unit,
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[500],
    margin: - theme.spacing.unit / 2,
  }
})

const GameInfoCardHeader = withStyles(stylesForGameInfoCardHeader, { withTheme: true })(props => {
  const { classes } = props

  const gameContext = useContext(GameContext)
  const room = gameContext.room

  return room !== undefined ? (
    <CardHeader
      subheader={
        <Typography>
          <span className={classes.roomNumber}>{room.groupLabel} / No.{room.name}</span>
          <span>{room.title ? room.title : ''}</span>
        </Typography>
      }
      action={room.lock ? (<VpnKeyIcon/>) : undefined}
      className={classes.cardHeader}
      classes={{
        action: classes.action
      }}
    />
  ) : (<React.Fragment></React.Fragment>)
})

const stylesForCardPlayersContent = theme => ({
  cardPlayersContent: {
    padding: `${theme.spacing.unit}px 0`,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
})

const CardPlayersContent = withStyles(stylesForCardPlayersContent, { withTheme: true })(props => {
  const { classes, disabledPlayerBox } = props

  return disabledPlayerBox !== true ? (
    <CardContent className={classes.cardPlayersContent}>
      <PlayerBox type={PLAYER_TYPE.PLAYER_1}/>
      <PlayerBox type={PLAYER_TYPE.PLAYER_2}/>
    </CardContent>
  ) : (
    <React.Fragment></React.Fragment>
  )
})

const stylesForCardDrawButtonsContent = theme => ({
  cardContent: {
    padding: 0,
  },
  gridContainer: {
    height: 97 - theme.spacing.unit,
    paddingTop: theme.spacing.unit,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  buttonFlexBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.unit,
  },
  button: {
    width: 150,
  },
  resultOfferDraw: {
    padding: theme.spacing.unit * 2,
  }
})

const CardDrawButtonsContent = withStyles(stylesForCardDrawButtonsContent, { withTheme: true })((props) => {
  const { classes, userSettings, room } = props
  const gameContext = useContext(GameContext)

  return room.status === roomStatus.PLAYING ? (
    <CardContent className={classes.cardContent}>
      <Collapse in={room.draw.offer}>
        {room.draw.offer === false ? (
          <Grid container className={classes.gridContainer}>
          </Grid>
        ) : room.draw.result === RESULT_OFFER_DRAW.NONE && room.turn !== undefined && userSettings !== undefined && room.turn.userName === userSettings.userName ? (
          <Grid container className={classes.gridContainer}>
            <Grid item xs={12}>
              <Typography align='center'>
                <Word wid={WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.ACCEPT_DRAW_GRID.TITLE}/>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.buttonFlexBox}>
                <Button variant='contained' color='primary' className={classes.button} onClick={() => gameContext.acceptDraw(room.groupName, room.name)}>
                  <Word wid={WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.ACCEPT_DRAW_GRID.YES}/>
                </Button>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.buttonFlexBox}>
                <Button variant='contained' className={classes.button} onClick={() => gameContext.denyDraw(room.groupName, room.name)}>
                  <Word wid={WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.ACCEPT_DRAW_GRID.NO}/>
                </Button>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid container className={classes.gridContainer}>
            <Grid item xs={12}>
              <Typography align='center'>
                <Word wid={WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.OFFER_DRAW_GRID.TITLE}/>
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.resultOfferDraw}>
              {room.draw.result === RESULT_OFFER_DRAW.NONE ? (
                <Typography align='center' variant='title'>
                  <Word wid={WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.OFFER_DRAW_GRID.OFFERING}/>
                </Typography>
              ) : room.draw.result === RESULT_OFFER_DRAW.ACCEPT ? (
                <Typography align='center' variant='title'>
                  <Word wid={WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.OFFER_DRAW_GRID.ACCEPT}/>
                </Typography>
              ) : room.draw.result === RESULT_OFFER_DRAW.DENY ? (
                <Typography align='center' variant='title'>
                  <Word wid={WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.OFFER_DRAW_GRID.DENY}/>
                </Typography>
              ) : (<React.Fragment></React.Fragment>)}
            </Grid>
          </Grid>
        )}
      </Collapse>
    </CardContent>
  ) : (
    <React.Fragment></React.Fragment>
  )
})

const stylesForCardUndoButtonsContent = theme => ({
  cardContent: {
    padding: 0,
  },
  gridContainer: {
    height: 120,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  buttonFlexBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.unit,
  },
  button: {
    width: 150,
  },
  resultOfferDraw: {
    padding: theme.spacing.unit * 2,
  }
})

const CardUndoButtonsContent = withStyles(stylesForCardUndoButtonsContent, { withTheme: true })((props) => {
  const { classes, userSettings, room } = props
  const gameContext = useContext(GameContext)

  var targetMoveString
  if (room.undo && room.undo.offer && room.undo.numberOfUndo) {
    let move = room.moves.find(move => move.number === room.undo.numberOfUndo)
    targetMoveString = `${move.color === 'black' ? '● ' : move.color === 'white' ? '○ ' : ''}${room.undo.numberOfUndo} (${coordinateXString[move.x]}${coordinateYString[14 - move.y]})`
  }
  return room.status === roomStatus.PLAYING ? (
    <CardContent className={classes.cardContent}>
      <Collapse in={room.undo.offer}>
        {room.undo.offer === false ? (
          <Grid container className={classes.gridContainer}>
          </Grid>
        ) : room.undo.player !== undefined && userSettings !== undefined && room.undo.player.userName !== userSettings.userName ? (
          <Grid container className={classes.gridContainer}>
            <Grid item xs={12}>
              <Typography align='center'>
                <Word wid={WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.ACCEPT_UNDO_GRID.TITLE}/>
              </Typography>
              <Typography align='center' variant='subheading'>{targetMoveString}</Typography>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.buttonFlexBox}>
                <Button variant='contained' color='primary' className={classes.button} onClick={() => gameContext.acceptUndo(room.groupName, room.name)}>
                  <Word wid={WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.ACCEPT_UNDO_GRID.YES}/>
                </Button>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.buttonFlexBox}>
                <Button variant='contained' className={classes.button} onClick={() => gameContext.denyUndo(room.groupName, room.name)}>
                  <Word wid={WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.ACCEPT_UNDO_GRID.NO}/>
                </Button>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid container className={classes.gridContainer}>
            <Grid item xs={12}>
              <Typography align='center'>
                <Word wid={WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.OFFER_UNDO_GRID.TITLE}/>
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.resultOfferDraw}>
              <Typography align='center' variant='title'>
                <Word wid={WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.OFFER_UNDO_GRID.OFFERING}/>
              </Typography>
            </Grid>
          </Grid>
        )}
      </Collapse>
    </CardContent>
  ) : (
    <React.Fragment></React.Fragment>
  )
})


const stylesForCardButtonsContent = theme => ({
  cardButtonsContent: {
    padding: 0,
  },
  gridContainer: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  buttonBase: {
    width: '100%',
    textAlign: 'center',
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    color: theme.palette.grey[700]
  },
  buttonFlexBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
  },
  iconFlexBox: {
    display: 'flex',
    height: theme.spacing.unit * 4,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing.unit,
  },
})

const CardButtonsContent = withStyles(stylesForCardButtonsContent, { withTheme: true })(props => {
  const { classes, theme, room, userSettings, handleOpenDialog } = props
  var styles, disabledDrawButton, disalbedNewGameButton, disabledRestartButton, disabledJoinButton, disabledUndoButton
  const gameContext = useContext(GameContext)
  disabledDrawButton = Boolean(
    room.turn === undefined ||
    userSettings === undefined ||
    room.turn.userName === userSettings.userName ||
    room.draw.offer === true
  )
  switch (room.status) {
    case roomStatus.EMPTY:
    case roomStatus.WAIT:
    case roomStatus.END:
      disalbedNewGameButton = Boolean(
        room.status !== roomStatus.END ||
        room.owner === undefined || userSettings === undefined ||
        room.owner.userName !== userSettings.userName
      )
      disabledRestartButton = Boolean(
        room.status !== roomStatus.END ||
        room.owner === undefined || userSettings === undefined ||
        room.owner.userName !== userSettings.userName ||
        room.player1 === undefined || room.player2 === undefined
      )
      disabledJoinButton = Boolean(
        room.player1 !== undefined &&
        room.player2 !== undefined &&
        userSettings !== undefined &&
        room.player1.userName !== userSettings.userName &&
        room.player2.userName !== userSettings.userName
      )
      styles = {
        newGameButton: {
          color: disalbedNewGameButton ? theme.palette.grey[200] : theme.palette.grey[700],
        },
        restartButton: {
          color: disabledRestartButton ? theme.palette.grey[200] : theme.palette.grey[700],
        },
        joinButton: {
          color: disabledJoinButton ? theme.palette.grey[200] : theme.palette.grey[700],
        }
      }
      return (
        <CardContent className={classes.cardButtonsContent}>
          <Collapse in={Boolean(userSettings !== undefined)}>
            <Grid container className={classes.gridContainer}>
              {userSettings !== undefined &&
               (room.player1 === undefined || room.player1.userName !== userSettings.userName) &&
               (room.player2 === undefined || room.player2.userName !== userSettings.userName) ? (
                <Grid item xs={4}>
                  <ButtonBase
                    className={classes.buttonBase}
                    onClick={() => gameContext.joinGame(room.groupName, room.name)}
                    style={styles.joinButton}
                    disabled={disabledJoinButton}
                  >
                    <div className={classes.buttonFlexBox}>
                      <div className={classes.iconFlexBox}>
                        <CallMadeIcon color='inherit'/>
                      </div>
                      <Typography color='inherit'>
                        <Word wid={WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.ENTER}/>
                      </Typography>
                    </div>
                  </ButtonBase>
                </Grid>
              ) : (
                <Grid item xs={4}>
                  <ButtonBase
                    className={classes.buttonBase}
                    onClick={() => gameContext.leaveGame(room.groupName, room.name)}
                    style={styles.joinButton}
                    disabled={disabledJoinButton}
                  >
                    <div className={classes.buttonFlexBox}>
                      <div className={classes.iconFlexBox}>
                        <CallReceivedIcon color='inherit'/>
                      </div>
                      <Typography color='inherit'>
                        <Word wid={WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.LEAVE}/>
                      </Typography>
                    </div>
                  </ButtonBase>
                </Grid>
              )}
              <Grid item xs={4}>
                <ButtonBase
                  className={classes.buttonBase}
                  onClick={() => gameContext.newGame(room.groupName, room.name)}
                  disabled={disalbedNewGameButton}
                  style={styles.newGameButton}
                >
                  <div className={classes.buttonFlexBox}>
                    <div className={classes.iconFlexBox}>
                      <AddIcon color='inherit'/>
                    </div>
                    <Typography color='inherit'>
                      <Word wid={WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.NEW}/>
                    </Typography>
                  </div>
                </ButtonBase>
              </Grid>
              <Grid item xs={4}>
                <ButtonBase
                  className={classes.buttonBase}  
                  onClick={() => gameContext.restartGame(room.groupName, room.name)}
                  disabled={disabledRestartButton}
                  style={styles.restartButton}
                >
                  <div className={classes.buttonFlexBox}>
                    <div className={classes.iconFlexBox}>
                      <CachedIcon color='inherit'/>
                    </div>
                    <Typography color='inherit'>
                      <Word wid={WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.REMATCH}/>
                    </Typography>
                  </div>
                </ButtonBase>
              </Grid>
            </Grid>
          </Collapse>
        </CardContent>
      )
    case roomStatus.PLAYING:
      disabledUndoButton = Boolean(
        (room.openingRule === OPENING_RULE.FREE && !room.moves.some(move => move.invalid !== true && move.number >= 2)) ||
        (room.openingRule === OPENING_RULE.SOOSYRV8 && !room.moves.some(move => move.invalid !== true && move.number >= 7)) ||
        room.turn === undefined || userSettings === undefined ||
        room.player1 === undefined || room.player2 === undefined ||
        room.enableUndo === false || room.undo.offer === true
      )
      styles = {
        buttonBase: {
          color: disabledDrawButton ? theme.palette.grey[200] : theme.palette.grey[700]
        },
        undoButtonBase: {
          color: disabledUndoButton ? theme.palette.grey[200] : theme.palette.grey[700]
        }
      }
      return (
        <CardContent className={classes.cardButtonsContent}>
          <Collapse
            in={Boolean(
              userSettings !== undefined &&
              room.status === roomStatus.PLAYING &&
              (room.player1.userName === userSettings.userName || room.player2.userName === userSettings.userName)
            )}
          >
            <Grid container className={classes.gridContainer}>
              <Grid item xs={4}>
                <ButtonBase
                  className={classes.buttonBase}
                  onClick={handleOpenDialog('resignConfirmDialog')}
                >
                  <div className={classes.buttonFlexBox}>
                    <div className={classes.iconFlexBox}>
                      <FlagIcon color='inherit'/>
                    </div>
                    <Typography color='inherit' noWrap>
                      <Word wid={WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.RESIGN}/>
                    </Typography>
                  </div>
                </ButtonBase>
              </Grid>
              <Grid item xs={4}>
                <ButtonBase
                  className={classes.buttonBase}
                  onClick={handleOpenDialog('drawConfirmDialog')}
                  style={styles.buttonBase}
                  disabled={disabledDrawButton}
                >
                  <div className={classes.buttonFlexBox}>
                    <div className={classes.iconFlexBox}>
                      <Typography variant='title' color='inherit'>1/2</Typography>
                    </div>
                    <Typography color='inherit' noWrap>
                      <Word wid={WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.DRAW}/>
                    </Typography>
                  </div>
                </ButtonBase>
              </Grid>
              <Grid item xs={4}>
                <ButtonBase
                  className={classes.buttonBase}
                  onClick={handleOpenDialog('undoConfirmDialog', room)}
                  style={styles.undoButtonBase}
                  disabled={disabledUndoButton}
                >
                  <div className={classes.buttonFlexBox}>
                    <div className={classes.iconFlexBox}>
                      <UndoIcon color='inherit'/>
                    </div>
                    <Typography color='inherit' noWrap>
                      <Word wid={WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.UNDO}/>
                    </Typography>
                  </div>
                </ButtonBase>
              </Grid>
            </Grid>
          </Collapse>
        </CardContent>
      )
    default:
      return (<React.Fragment></React.Fragment>)
  }
})

const stylesForCardGameInfoContent = theme => ({
  cardContent: {
    padding: 0,
  },
  buttonBase: {
    width: '100%',
    textAlign: 'center',
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  buttonBox: {
    textAlign: 'center',
    color: theme.palette.grey[700],
  },
  iconBox: {
    display: 'flex',
    height: theme.spacing.unit * 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
})

const CardGameInfoContent = withStyles(stylesForCardGameInfoContent, { withTheme: true })(props => {
  const { classes, theme } = props

  const gameInfoCardContext = useContext(GameInfoCardContext)
  const { selectedIndex, handleClickTab } = gameInfoCardContext

  var styles, argProps
  argProps = { ...props }
  delete argProps.classes
  styles = {
    chat: {
      backgroundColor: selectedIndex === 0 ? theme.palette.common.white : theme.palette.grey[100]
    },
    users: {
      backgroundColor: selectedIndex === 1 ? theme.palette.common.white : theme.palette.grey[100]
    },
    info: {
      backgroundColor: selectedIndex === 2 ? theme.palette.common.white : theme.palette.grey[100]
    },
    settings: {
      backgroundColor: selectedIndex === 3 ? theme.palette.common.white : theme.palette.grey[100]
    }
  }
  return (
    <CardContent className={classes.cardContent}>
      <Grid container>
        <Grid item xs={3}>
          <ButtonBase
            className={classes.buttonBase}
            style={styles.chat}
            onClick={handleClickTab(0)}
          >
            <div className={classes.buttonBox} style={styles.chat}>
              <div className={classes.iconBox}>
                <ChatBubbleIcon color='inherit'/>
              </div>
              <Typography color='inherit'>
                <Word wid={WID.GAME_INFO_CARD.CARD_GAME_INFO_CONTENT.TAB_BUTTONS.CHAT}/>
              </Typography>
            </div>
          </ButtonBase>
        </Grid>
        <Grid item xs={3}>
          <ButtonBase
            className={classes.buttonBase}
            style={styles.users}
            onClick={handleClickTab(1)}
          >
            <div className={classes.buttonBox}>
              <div className={classes.iconBox}>
                <GroupIcon color='inherit'/>
              </div>
              <Typography color='inherit'>
                <Word wid={WID.GAME_INFO_CARD.CARD_GAME_INFO_CONTENT.TAB_BUTTONS.USERS}/>
              </Typography>
            </div>
          </ButtonBase>
        </Grid>
        <Grid item xs={3}>
          <ButtonBase
            className={classes.buttonBase}
            style={styles.info}
            onClick={handleClickTab(2)}
          >
            <div className={classes.buttonBox}>
              <div className={classes.iconBox}>
                <InfoIcon color='inherit'/>
              </div>
              <Typography color='inherit'>
                <Word wid={WID.GAME_INFO_CARD.CARD_GAME_INFO_CONTENT.TAB_BUTTONS.INFORMATION}/>
              </Typography>
            </div>
          </ButtonBase>
        </Grid>
        <Grid item xs={3} style={styles.blank}>
        <ButtonBase
            className={classes.buttonBase}
            style={styles.settings}
            onClick={handleClickTab(3)}
          >
            <div className={classes.buttonBox}>
              <div className={classes.iconBox}>
                <SettingsIcon color='inherit'/>
              </div>
              <Typography color='inherit'>
                <Word wid={WID.GAME_INFO_CARD.CARD_GAME_INFO_CONTENT.TAB_BUTTONS.SETTINGS}/>
              </Typography>
            </div>
          </ButtonBase>
        </Grid>
      </Grid>
      {selectedIndex === 0 ? (<ChatBox {...argProps}/>) :
       selectedIndex === 1 ? (<UsersBox/>) :
       selectedIndex === 2 ? (<GameInfoBox {...argProps}/>) :
       selectedIndex === 3 ? (<SettingsBox key={"settings box"}/>) :
       (<React.Fragment></React.Fragment>)}
    </CardContent>
  )
})

const stylesForChatBox = theme => ({
  chatBox: {
    boxSizing: 'border-box',
    height: 430,
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px 0 ${theme.spacing.unit * 2}px`,
  },
  messagesBox: {
    height: messageBoxHeight,
    overflowY: 'scroll',
  },
  messageBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  chatAvatar: {
    width: theme.spacing.unit * 3,
    height: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    fontSize: '1em',
  },
  chatDisplayName: {
    display: 'inline-block',
    maxWidth: '100px',
    marginRight: theme.spacing.unit,
    color: theme.palette.grey[600],
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    verticalAlign: 'bottom',
  },
  chatMessage: {
  },
  chatActionsBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing.unit,
  },
  textMessageField: {
    width: '100%',
    maxWidth: 300,
  },
  userName: {
    color: blue[500],
  },
  gameMessage: {
    marginTop: theme.spacing.unit / 2,
    marginBottom: theme.spacing.unit / 2,
  },
  gameResultBox: {
    maxWidth: 300,
    margin: `${theme.spacing.unit * 3}px auto`,
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: theme.spacing.unit,
    padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
    textAlign: 'center',
  },
  gameRecordButton: {
    marginTop: theme.spacing.unit * 3,
  },
  openInNewIcon: {
    fontSize: 'inherit',
    marginLeft: theme.spacing.unit,
  },
  chip: {
    marginRight: theme.spacing.unit,
    height: 'unset',
    backgroundColor: theme.palette.grey[100],
  }
})

const messageBoxHeight = 350
const scrollTime = 300
const fps = 100

const ChatBox = withStyles(stylesForChatBox, { withTheme: true })((props) => {
  const { classes, room, message, handleTextChange, onClickSendMessage, onKeyDown, language } = props

  var disabledSendButton, reasonStr
  disabledSendButton = Boolean(message.length === 0)

  const [isInitialized, setIsInitialized] = useState(false)
  const [scrollDiff, setScrollDiff] = useState(undefined)
  const [scrollStart, setScrollStart] = useState(undefined)
  const [frameCount, setFrameCount] = useState(0)
  const [time, setTime] = useState(Date.now())
  const [isScrolled, setIsScrolled] = useState(false)
  const [intervalId, setIntervalId] = useState(undefined)
  const prevIsScrolled = useRef(isScrolled)

  const gameContext = useContext(GameContext)
  var messages = gameContext.chat.messages.length > 0 ? gameContext.chat.messages.filter(message => message.groupName === room.groupName && message.roomName === room.name) : []
  messages.sort((a, b) => Boolean(a.datetime < b.datetime))
  const prevMessages = useRef(messages)

  var obj = document.getElementById('messagesBox')
  var diff = obj ? obj.scrollHeight - messageBoxHeight - obj.scrollTop : 0

  useEffect(() => {
    if (!isInitialized) {
      var obj = document.getElementById('messagesBox')
      if (obj) {
        obj.scrollTop = obj.scrollHeight
      }
      setIsInitialized(true)
    }
  }, [isInitialized])

  useEffect(() => {
    if (
      messages && prevMessages.current &&
      messages.length > prevMessages.current.length &&
      (0 === diff || isScrolled)
    ) {
      setTimeout(() => {
        obj = document.getElementById('messagesBox')
        if (obj) {
          setScrollDiff(obj.scrollHeight - messageBoxHeight - obj.scrollTop)
          setScrollStart(obj.scrollTop)
          setFrameCount(1)
          setIsScrolled(true)
        }
      }, 1)
    }

    prevMessages.current = messages
  }, [messages])

  useEffect(() => {
    if (isScrolled && !prevIsScrolled.current.isScrolled) {
      setIntervalId(setInterval(() => setTime(Date.now()), 1000 / fps))
    }
    if (!isScrolled && prevIsScrolled.current.isScrolled) {
      clearInterval(intervalId)
    }
    if (isScrolled) {
      var obj, rate
      obj = document.getElementById('messagesBox')

      if (obj) {
        rate = frameCount / (scrollTime * fps / 1000)
        diff = obj.scrollHeight - messageBoxHeight - obj.scrollTop
        if (1 >= rate) {
          obj.scrollTop = scrollStart + scrollDiff * rate * (2 - rate)
          setFrameCount(frameCount + 1)
        }
        else {
          setIsScrolled(false)
        }
      }
    }
    prevIsScrolled.current = { isScrolled, time }
  }, [isScrolled, time])

  const handleCancelScroll = () => {
    if (isScrolled) {
      setIsScrolled(false)
    }
  }

  return (
    <div className={classes.chatBox}>
      <div className={classes.messagesBox} id='messagesBox' onMouseDown={handleCancelScroll} onTouchStart={handleCancelScroll} onWheel={handleCancelScroll}>
        {messages.sort((a, b) => { return a.datetime > b.datetime }).map((msg, index) => {
          switch(msg.type) {
            case CHAT_TYPE.MESSAGE:
              return (
                <div className={classes.messageBox} key={index}>
                  <CustomAvatar
                    alt={msg.user.displayName}
                    name={msg.user.displayName}
                    src={msg.user.avatarPhotoURL}
                    className={classes.chatAvatar}
                  />
                  <Typography color='inherit'>
                    <span className={classes.chatDisplayName}>{msg.user.userName}</span>
                    <span className={classes.chatMessage}>{msg.message}</span>
                  </Typography>
                </div>
              )
            case CHAT_TYPE.JOIN_ROOM:
              return (
                <div key={index}>
                  <Typography><span className={classes.userName}>{msg.user.displayName}{msg.user.userName ? `@${msg.user.userName}` : ''}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_ENTERED_THE_ROOM}/></Typography>
                </div>
              )
            case CHAT_TYPE.LEAVE_ROOM:
              return (
                <div key={index}>
                  <Typography><span className={classes.userName}>{msg.user.displayName}{msg.user.userName ? `@${msg.user.userName}` : ''}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_LEFT_THE_ROOM}/></Typography>
                </div>
              )
            case CHAT_TYPE.GAME_START:
              return (
                <div key={index}>
                  <Typography className={classes.gameMessage}><Chip className={classes.chip} label={<Word wid={WID.GAME_INFO_CARD.CHAT_BOX.GAME_START_CHIP}/>} component='span'/> <span className={classes.userName}>{msg.player1.userName}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_VS}/> <span className={classes.userName}>{msg.player2.userName}</span></Typography>
                </div>
              )
            case CHAT_TYPE.GAME_RESULT:
              switch(msg.gameResult.action) {
                case ENDED_ACTION.FIVE:
                  reasonStr = (<Typography className={classes.gameMessage}><Chip className={classes.chip} label={<Word wid={WID.GAME_INFO_CARD.CHAT_BOX.GAME_FINISH_CHIP}/>} component='span'/> <span className={classes.userName}>{msg.gameResult.user.userName}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_MAKE_A_FIVE_IN_A_ROW}/></Typography>)
                  break
                case ENDED_ACTION.RESIGN:
                  reasonStr = (<Typography className={classes.gameMessage}><Chip className={classes.chip} label={<Word wid={WID.GAME_INFO_CARD.CHAT_BOX.GAME_FINISH_CHIP}/>} component='span'/> <span className={classes.userName}>{msg.gameResult.user.userName}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_WAS_RESIGNED}/></Typography>)
                  break
                case ENDED_ACTION.OFFER_DRAW:
                  reasonStr = (<Typography className={classes.gameMessage}><Chip className={classes.chip} label={<Word wid={WID.GAME_INFO_CARD.CHAT_BOX.GAME_FINISH_CHIP}/>} component='span'/> <span className={classes.userName}>{msg.gameResult.user.userName}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_ACCEPTED_THE_DRAW_PROPOSAL}/></Typography>)
                  break
                case ENDED_ACTION.TIMEOUT:
                  reasonStr = (<Typography className={classes.gameMessage}><Chip className={classes.chip} label={<Word wid={WID.GAME_INFO_CARD.CHAT_BOX.GAME_FINISH_CHIP}/>} component='span'/> <span className={classes.userName}>{msg.gameResult.user.userName}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_WAS_OUT_OF_TIME}/></Typography>)
                  break
                default:
                  reasonStr = (<React.Fragment/>)
                  break
              }
              return (
                <div key={index}>
                  {reasonStr}
                  <div className={classes.gameResultBox}>
                    <GameResultBox gameResult={msg.gameResult}/>
                    <Button className={classes.gameRecordButton} variant='outlined' href={msg.url} target='_blank'>
                      <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.GAME_RECORD_BUTTON}/>
                      <OpenInNewIcon className={classes.openInNewIcon} color='inherit'/>
                    </Button>
                  </div>
                </div>
              )
            case CHAT_TYPE.LOCK:
              return (
                <div key={index}>
                  <Typography><span className={classes.userName}>{msg.user.displayName}@{msg.user.userName}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.LOCK}/></Typography>
                </div>
              )
            case CHAT_TYPE.UNLOCK:
              return (
                <div key={index}>
                  <Typography><span className={classes.userName}>{msg.user.displayName}@{msg.user.userName}</span> <Word wid={WID.GAME_INFO_CARD.CHAT_BOX.UNLOCK}/></Typography>
                </div>
              )
            default:
              return (<React.Fragment></React.Fragment>)
          }
        })}
      </div>
      <div className={classes.chatActionsBox}>
        <TextField
          className={classes.textMessageField}
          placeholder={getWord(WID.GAME_INFO_CARD.CHAT_BOX.ENTER_A_MESSAGE, language)}
          value={message}
          onChange={handleTextChange('message')}
          onKeyDown={onKeyDown(message)}
        />
        <IconButton
          color="primary"
          disabled={disabledSendButton}
          onClick={onClickSendMessage(message)}
        >
          <SendIcon/>
        </IconButton>
      </div>
    </div>
  )
})

const stylesUsersBox = theme => ({
  usersBox: {
    padding: theme.spacing.unit * 2,
    height: 430,
    boxSizing: 'border-box',
    overflowY: 'auto'
  },
  userBox: {
    display: 'flex',
    alignItems: 'center',
    margin: `0 0 ${theme.spacing.unit * 2}px 0`,
    color: theme.palette.grey[800],
    textDecoration: 'none',
  },
  userAvatar: {
    width: theme.spacing.unit * 5,
    height: theme.spacing.unit * 5,
    marginRight: theme.spacing.unit,
  },
})

const UsersBox = withStyles(stylesUsersBox, { withTheme: true })((props) => {
  var roomUsers
  const { classes } = props

  const gameContext = useContext(GameContext)
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  roomUsers = gameContext.getRoomUsers()

  return (
    <div className={classes.usersBox}>
      {roomUsers.map((user, index) => {
        return user.userName ? (          
          <Link to={makePath(`/user/${user.userName}`, language)} target={'_blank'} className={classes.userBox} key={user.userName}>
            <CustomAvatar
              name={user.displayName}
              alt={user.displayName}
              src={user.avatarPhotoURL}
              className={classes.userAvatar}
            />
            <div>
              {user.displayName && (
                <Typography color='inherit'>{user.displayName}</Typography>
              )}
              {user.userName && (
                <Typography color='inherit'>{`@${user.userName}`}</Typography>
              )}
            </div>
          </Link>
        ) : (
          <div className={classes.userBox} key={index}>
            <CustomAvatar
              name={user.displayName}
              alt={user.displayName}
              src={user.avatarPhotoURL}
              className={classes.userAvatar}
            />
            <div>
              {user.displayName && (
                <Typography color='inherit'>{user.displayName}</Typography>
              )}
              {user.userName && (
                <Typography color='inherit'>{`@${user.userName}`}</Typography>
              )}
            </div>
          </div> 
        )
      })}
    </div>
  )
})

const stylesForGameInfoBox = theme => ({
  gameInfoBox: {
    boxSizing: 'border-box',
    height: 430,
    padding: theme.spacing.unit * 2,
    color: theme.palette.grey[800],
    overflowY: 'auto'
  },
  gameInfoItems: {
    lineHeight: 2,
  },
  gameResultStr: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  divider: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  }
})

const GameInfoBox = withStyles(stylesForGameInfoBox, { withTheme: true })((props) => {
  const { classes, room } = props
  var item, openingRuleStr, timeLimitStr, increaseSecondStr
  item = openingRuleItems.find(it => it.value === room.openingRule)
  openingRuleStr = item !== undefined ? <Word wid={item.wid}/> : ''
  timeLimitStr = room.minute !== undefined ? room.minute : '-'
  increaseSecondStr = room.increaseSecond !== undefined ? room.increaseSecond : '-'
  switch (room.gameType) {
    case gameType.LIVE_GAME:
      return ( 
        <div className={classes.gameInfoBox}>
          <Typography color='inherit' className={classes.gameInfoItems}><Word wid={WID.GAME_INFO_CARD.GAME_INFO_BOX.ROOM_LABEL}/>{`: ${room.groupLabel} / No.${room.name}`}</Typography>
          <Typography color='inherit' className={classes.gameInfoItems}><Word wid={WID.GAME_INFO_CARD.GAME_INFO_BOX.OPENING_RULE_LABEL}/>{`: `}{openingRuleStr}</Typography>
          <Typography color='inherit' className={classes.gameInfoItems}><Word wid={WID.GAME_INFO_CARD.GAME_INFO_BOX.TIME}/>{`: ${timeLimitStr} `}<Word wid={WID.GAME_INFO_CARD.GAME_INFO_BOX.MINUTES}/></Typography>
          <Typography color='inherit' className={classes.gameInfoItems}><Word wid={WID.GAME_INFO_CARD.GAME_INFO_BOX.TIME_INCREMENTS}/>{`: ${increaseSecondStr} `}<Word wid={WID.GAME_INFO_CARD.GAME_INFO_BOX.SECONDS}/></Typography>
          {room.status === roomStatus.END && (
            <div>
              <Divider className={classes.divider}/>
              <GameResultBox gameResult={room.gameResult}/>
              <Typography className={classes.gameResultStr} color='inherit' align='center'>
                {makeLiveGameResultStr(room.gameResult)}
              </Typography>
            </div>
          )}
        </div>
      )
    case gameType.DAILY_GAME:
      return ( 
        <div className={classes.gameInfoBox}>
          <Typography className={classes.gameInfoItems}><Word wid={WID.GAME_INFO_CARD.GAME_INFO_BOX.OPENING_RULE_LABEL}/>{`: ${openingRuleStr}`}</Typography>
        </div>
      )
    default:
      return (
        <React.Fragment></React.Fragment>
      )
  }
})

const stylesSettingsBox = theme => ({
  root: {
    padding: theme.spacing.unit * 2,
    height: 430,
    boxSizing: 'border-box',
    overflowY: 'auto'
  },
})

const SettingsBox = withStyles(stylesSettingsBox, { withTheme: true })((props) => {
  const { classes } = props
  const gameInfoCardContext = useContext(GameInfoCardContext)
  const { groupName, roomName } = gameInfoCardContext
  const gameContext = useContext(GameContext)

  var disabledPrivateGame = !gameContext.isOwner()
  var isLocked = gameContext.isLocked()

  const handleChange = () => {
    if (isLocked) {
      gameContext.unlock(groupName, roomName)
    }
    else {
      gameInfoCardContext.setOpenPrivateGameKeyDialog(true)
    }
  }

  
  return (
    <div className={classes.root}>
        <List>
          <ListItem disabled={disabledPrivateGame}>
            <ListItemText><Word wid={WID.GAME_INFO_CARD.SETTINGS_BOX.PRIVATE_GAME}/></ListItemText>
            <ListItemSecondaryAction>
              <Switch
                checked={isLocked}
                onChange={handleChange}
                color={"primary"}
                disabled={disabledPrivateGame}
              />
            </ListItemSecondaryAction>
          </ListItem>
        </List>
    </div>
  )
})

const PrivateGameKeyDialog = (props) => {
  const gameInfoCardContext = useContext(GameInfoCardContext)
  const gameContext = useContext(GameContext)

  const handleClickOK = () => {
    gameInfoCardContext.setOpenPrivateGameKeyDialog(false)
    gameContext.lock(gameInfoCardContext.groupName, gameInfoCardContext.roomName, gameInfoCardContext.password)
  }

  const handleClickCancel = () => {
    gameInfoCardContext.setOpenPrivateGameKeyDialog(false)
  }

  var prevOpen = useRef(gameInfoCardContext.openPrivateGameKeyDialog)

  useEffect(() => {
    if (
      !prevOpen.current &&
      gameInfoCardContext.openPrivateGameKeyDialog
    ) {
      gameInfoCardContext.setPassword('')
    }
    prevOpen.current = gameInfoCardContext.openPrivateGameKeyDialog
  }, [gameInfoCardContext.openPrivateGameKeyDialog])

  return (
    <Dialog open={gameInfoCardContext.openPrivateGameKeyDialog} onClose={() => gameInfoCardContext.setOpenPrivateGameKeyDialog(false)}>
      <DialogContent>

        <FormControl>
          <InputLabel htmlFor="standard-adornment-password"><Word wid={WID.GAME_INFO_CARD.PRIVATE_GAME_KEY_DIALOG.LABEL}/></InputLabel>
          <Input
            id="standard-adornment-password"
            type={gameInfoCardContext.visiblePassword ? 'text' : 'password'}
            value={gameInfoCardContext.password}
            onChange={gameInfoCardContext.handleChangePassword}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => gameInfoCardContext.setVisiblePassword(!gameInfoCardContext.visiblePassword)}
                >
                  {gameInfoCardContext.visiblePassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleClickCancel} color='primary'>Cancel</Button>
        <Button onClick={handleClickOK} color='primary'>OK</Button>
      </DialogActions>
    </Dialog>
  )
}

function NumberForUndoTextField(props) {
  var moves
  const { room, numberOfUndo, handleChange } = props

  if (
    (room.openingRule === OPENING_RULE.SOOSYRV8 && !room.moves.some(move => move.invalid !== true && move.number >= 7)) ||
    (room.openingRule === OPENING_RULE.FREE     && !room.moves.some(move => move.invalid !== true && move.number >= 2))
  ) {
    return (
      <React.Fragment/>
    )
  }

  switch (room.openingRule) {
    case OPENING_RULE.FREE: {
      moves = room.moves.filter(move => move.invalid !== true && move.number && move.number >= 1)
      moves.pop()
      break
    }
    case OPENING_RULE.SOOSYRV8: {
      moves = room.moves.filter(move => move.invalid !== true && move.number && move.number >= 6)
      moves.pop()
      break
    }
    default: {
      break
    }
  }

  return (
    <TextField
      select
      value={numberOfUndo}
      onChange={handleChange('numberOfUndo')}
      margin='normal'
    >
      {moves.filter(move => move.invalid !== true).map(move => {
        let color = move.color === 'black' ? '●' : move.color === 'white' ? '○' : ''
        return (
          <MenuItem key={move.number} value={`${move.number}`}>
            <Typography>{color} {move.number} ({coordinateXString[move.x]}{coordinateYString[14 - move.y]})</Typography>
          </MenuItem>
        )
      })}
    </TextField>
  )
}


const styles = theme => ({
  card: {
    maxWidth: 680,
    margin: '0 auto',
  },
  cardContent: {
    padding: `${theme.spacing.unit}px 0 0 0`,
  },
  cardActions: {
    padding: 0.
  },
})

const GameInfoCardContext = React.createContext()

const GameInfoCard = (props) => {
  const [openForResignConfirmDialog, setOpenForResignConfirmDialog] = useState(false)
  const [openForDrawConfirmDialog, setOpenForDrawConfirmDialog] = useState(false)
  const [openForUndoConfirmDialog, setOpenForUndoConfirmDialog] = useState(false)
  const [openPrivateGameKeyDialog, setOpenPrivateGameKeyDialog] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [message, setMessage] = useState('')
  const [numberOfUndo, setNumberOfUndo] = useState('1')
  const [enablePrivateGame, setEnablePrivateGame] = useState(false)
  const [password, setPassword] = useState('')
  const [visiblePassword, setVisiblePassword] = useState(false)

  const gameContext = useContext(GameContext)
  
  const { classes, theme, width, bid, groupName, roomName, isVisibleOpeningRuleControlBox, isVisibleControlButtons } = props

  const room = gameContext.room

  const { xs } = getBreakpointsEnable(theme, width)

  const handleOpenDialog = (name) => () => {
    switch (name) {
      case 'undoConfirmDialog': {
        let moves = room.moves.filter(move => move.invalid !== true && move.number && move.number > 0)
        if (moves.length > 1) {
          setOpenForUndoConfirmDialog(true)
          setNumberOfUndo(`${moves[moves.length - 2].number}`)
        }
        break
      }
      case 'resignConfirmDialog':
        setOpenForResignConfirmDialog(true)
        break
      case 'drawConfirmDialog':
        setOpenForDrawConfirmDialog(true)
        break
      default:
        break
    }
  }

  const handleClose = (name) => () => {
    switch (name) {
      case 'undoConfirmDialog':
        setOpenForUndoConfirmDialog(false)
        break
      case 'resignConfirmDialog':
        setOpenForResignConfirmDialog(false)
        break
      case 'drawConfirmDialog':
        setOpenForDrawConfirmDialog(false)
        break
      default:
        break
    }
  }
  
  const handleOK = (name) => () => {
    switch(name) {
      case 'resignConfirmDialog':
        gameContext.resign(room.groupName, room.name)
        setOpenForResignConfirmDialog(false)
        break
      case 'drawConfirmDialog':
        gameContext.offerDraw(room.groupName, room.name)
        setOpenForDrawConfirmDialog(false)
        break
      case 'undoConfirmDialog':
        gameContext.offerUndo(numberOfUndo, room.groupName, room.name)
        setOpenForUndoConfirmDialog(false)
        break 
      default:
        break
    }
  }
  

  const handleClickTab = (selectedIndex) => () => {
    setSelectedIndex(selectedIndex)
  }

  const handleTextChange = (name) => (event) => {
    switch (name) {
      case 'message': 
        setMessage(event.target.value)
        break
      default:
        break
    }
  }

  const handleClickSendMessage = (message) => () => {
    gameContext.chatMessage(room.groupName, room.name, message)
    setMessage('')
  } 

  const handleKeyDown = (message) => (event) => {
    if (event.keyCode === 13){
      gameContext.chatMessage(room.groupName, room.name, message)
      setMessage('')
    }
  }

  const handleChange = (name) => (event) => {
    switch (name) {
      case 'numberOfUndo': 
        setNumberOfUndo(event.target.value)
        break
      default:
        break
    }
  }

  const handleChangePassword = (event) => {
    setPassword(event.target.value)
  }

  var styles = {
    card: {
      marginTop: xs ? theme.spacing.unit : undefined
    }
  }
  var argProps
  argProps = { ...props, room, message }
  delete argProps.classes

  return room !== undefined ? (
    <GameInfoCardContext.Provider
      value={{
        setOpenForResignConfirmDialog,
        setOpenForDrawConfirmDialog,
        setOpenForUndoConfirmDialog,
        setOpenPrivateGameKeyDialog,
        setSelectedIndex,
        setMessage,
        setNumberOfUndo,
        setEnablePrivateGame,
        setVisiblePassword,
        setPassword,
        handleOpenDialog,
        handleClose,
        handleOK,
        handleClickTab,
        handleTextChange,
        handleClickSendMessage,
        handleKeyDown,
        handleChange,
        handleChangePassword,
        openForResignConfirmDialog,
        openForDrawConfirmDialog,
        openForUndoConfirmDialog,
        openPrivateGameKeyDialog,
        selectedIndex,
        message,
        numberOfUndo,
        enablePrivateGame,
        groupName,
        roomName,
        password,
        visiblePassword,
      }}
    >
      <Card className={classes.card} style={styles.card}>
        <GameInfoCardHeader room={room}/>
        <CardPlayersContent {...argProps}/>
        {room.status === roomStatus.PLAYING && (
          <ControlCard {...{ bid, component: 'CardContent', isVisibleOpeningRuleControlBox, isVisibleControlButtons }}/>
        )}
        <CardDrawButtonsContent {...{...argProps}} />
        <CardUndoButtonsContent {...{...argProps}} />
        <CardButtonsContent {...{...argProps, handleOpenDialog: handleOpenDialog}}/>
        <CardGameInfoContent {...{...argProps, selectedIndex, handleClickTab: handleClickTab, handleTextChange: handleTextChange, onClickSendMessage: handleClickSendMessage, onKeyDown: handleKeyDown }}/>
        <CardActions className={classes.cardActions}/>
      </Card>
      <ConfirmDialog
        open={openForResignConfirmDialog}
        title={<Word wid={WID.GAME_INFO_CARD.RESIGN_CONFIRM_DIALOG.TITLE}/>}
        onOK={handleOK('resignConfirmDialog')}
        onClose={handleClose('resignConfirmDialog')}
      />
      <ConfirmDialog
        open={openForDrawConfirmDialog}
        title={<Word wid={WID.GAME_INFO_CARD.DRAW_CONFIRM_DIALOG.TITLE}/>}
        onOK={handleOK('drawConfirmDialog')}
        onClose={handleClose('drawConfirmDialog')}
      />
      <ConfirmDialog
        open={openForUndoConfirmDialog}
        title={<Word wid={WID.GAME_INFO_CARD.UNDO_CONFIRM_DIALOG.TITLE}/>}
        content={<NumberForUndoTextField {...{ room, numberOfUndo, handleChange }}/>}
        onOK={handleOK('undoConfirmDialog')}
        onClose={handleClose('undoConfirmDialog')}
      />
      <PrivateGameKeyDialog/>
    </GameInfoCardContext.Provider>
  ) : (
    <React.Fragment></React.Fragment>
  )
}

export default withStyles(styles, { withTheme: true })(GameInfoCard)


// WEBPACK FOOTER //
// ./src/Pages/Game/components/GameInfoCard.js